import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.786 5.008 10.896.21a.73.73 0 0 0-.514-.21H.727A.72.72 0 0 0 0 .714v18.552a.72.72 0 0 0 .727.714h14.546a.72.72 0 0 0 .727-.714V5.515a.7.7 0 0 0-.214-.507m-1.463.834h-4.277V1.646zm.04 12.533H1.637V1.605H8.5v4.817c0 .249.1.487.28.662a.96.96 0 0 0 .675.275h4.909zm-6.315-6.866L6.643 9.225a.28.28 0 0 0-.234-.13h-.873a.26.26 0 0 0-.145.043.264.264 0 0 0-.084.37l1.87 2.908-1.895 2.961a.265.265 0 0 0 .093.373q.064.038.139.038h.784c.095 0 .182-.05.232-.127l1.425-2.264 1.415 2.261c.05.08.14.128.232.128h.852a.3.3 0 0 0 .148-.043.264.264 0 0 0 .082-.37l-1.909-2.908 1.939-2.954a.264.264 0 0 0-.091-.375.3.3 0 0 0-.139-.038h-.811a.28.28 0 0 0-.234.13z"
    }, null, -1)
  ]))]))
}
export default { render: render }